import type { ConfigDimension, FieldConfig, ScopeConfig } from './types';
import { DimensionKey, MediumType, ScopeKey } from './types';

export const energyTabs: { key: MediumType; label: string }[] = [
  { key: MediumType.Electricity, label: '电' },
  { key: MediumType.NaturalGas, label: '天然气' },
  { key: MediumType.CompressedAir, label: '压缩空气' },
  { key: MediumType.CarbonDioxide, label: '二氧化碳' },
  { key: MediumType.Oxygen, label: '氧气' },
  { key: MediumType.Argon, label: '氩气' },
];

export const scopeTabs: { key: ScopeKey; label: string }[] = [
  { key: ScopeKey.Factory, label: '全厂' },
  { key: ScopeKey.Station, label: '站房' },
  { key: ScopeKey.Area, label: '区域' },
  { key: ScopeKey.Outlet, label: '出口' },
];

export const numberRule = {
  pattern: /^(0|[1-9]\d{0,7})(\.\d{1,2})?$/,
  message: '请输入0~99999999.99范围内的数字',
};

export const scopeDimensionMap: Record<ScopeKey, ConfigDimension> = {
  [ScopeKey.Factory]: DimensionKey.Plant,
  [ScopeKey.Station]: DimensionKey.Station,
  [ScopeKey.Area]: DimensionKey.Area,
  [ScopeKey.Outlet]: DimensionKey.Outlet,
  [ScopeKey.Compressor]: DimensionKey.Compressor,
};

const commonMeterField: FieldConfig = {
  name: 'flowMeterDeviceIds',
  label: '对应流量计',
  dataIndex: 'flowMeters',
};

const commonGasSourceField: FieldConfig = {
  name: 'gasSources',
  label: '气体来源',
};

export const scopeConfigs: Record<ScopeKey, ScopeConfig> = {
  factory: {
    label: '全厂',
    fields: [
      commonMeterField,
      {
        name: 'ratedFlow',
        label: '气化额定流速',
        unit: 'Nm³/h',
      },
    ],
  },
  station: {
    label: '站房',
    fields: [
      {
        name: 'stationName',
        label: '站房名称',
      },
      commonMeterField,
      {
        name: 'ratedFlow',
        label: '气化器额定标方速度',
        unit: 'Nm³/h',
      },
    ],
  },
  area: {
    label: '区域',
    fields: [
      {
        name: 'areaName',
        label: '区域名称',
      },
      commonGasSourceField,
      commonMeterField,
      {
        name: 'ratedFlow',
        label: '区域点位额定流量',
        unit: 'Nm³/h',
      },
    ],
  },
  outlet: {
    label: '出口',
    fields: [
      {
        name: 'outletName',
        label: '出口点位名称',
      },
      commonGasSourceField,
      commonMeterField,
      {
        name: 'ratedFlow',
        label: '出口点位额定流量',
        unit: 'Nm³/h',
      },
    ],
  },
  compressor: {
    label: '空压机',
    fields: [
      {
        name: 'compressorName',
        label: '空压机名称',
      },
      commonMeterField,
      {
        name: 'ratedFlow',
        label: '空压机额定标方产气速度',
        unit: 'Nm³/h',
      },
    ],
  },
};

export const electricityConfig: ScopeConfig = {
  label: '电',
  fields: [
    {
      name: 'circuitName',
      label: '回路名称',
    },
    {
      name: 'circuitCode',
      label: '回路编码',
    },
    {
      name: 'circuitStart',
      label: '回路起点',
    },
    {
      name: 'circuitEnd',
      label: '回路终点',
    },
    {
      name: 'ratedCurrent',
      label: '线路额定电流',
      unit: 'A',
    },
  ],
};
